import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { City, Country, State } from "country-state-city";
import { getRegister } from "../../../service/AuthenticationService";
import { PhoneInput } from "react-international-phone";
import { Link } from "react-router-dom";
import "./Register.css";

const Register = (props) => {
  const { logo } = props;
  let countryData = Country.getAllCountries();
  const navigate = useNavigate();
  const [showpassword, setShowPassword] = useState(false);
  const [showconfirmpassword, setShowConfirmPassword] = useState(false);
  const [stateData, setStateData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyUrl, setCompanyUrl] = useState("");
  const [jobTitle, setJobtitle] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [address, setAddress] = useState("");
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [getImage, setGetImage] = useState(null);
  const [getImageresult, setGetImageresult] = useState("");
  const [image, setImage] = useState({ preview: "", raw: "" });
  const [countryName, setCountryName] = useState({});
  const [check, setCheck] = useState(false);
  const [phone, setPhone] = useState("");
  const [employee, setEmployee] = useState("");
  const [operatorUnit, setOperatorUnit] = useState("");
  const [supplier, setSupplier] = useState("");
  const [onlySupplier, setOnlySupplier] = useState(false);
  const [companySupplier, setCompanySupplier] = useState(false);
  const [hasUpperCase, setHasUpperCase] = useState(false);
  const [hasLowerCase, setHasLowerCase] = useState(false);
  const [hasNumber, setHasNumber] = useState(false);
  const [hasSpecialChar, setHasSpecialChar] = useState(false);
  const [minTenChars, setMinTenChars] = useState(false);

  // console.log(phone, "phone");
  const onCheckbox = (e) => {
    setCheck(e.target.checked);
  };

  const onFile = (event) => {
    // console.log(event.target.files[0], "filee");
    if (event["target"].files.length > 0) {
      const file = event["target"].files[0];
      // setUserData({...userData, profileImage : file});
      setImage({
        preview: URL.createObjectURL(event.target.files[0]),
        raw: event.target.files[0],
      });
      // console.log(image, "101823");
      setGetImage(file);
      setGetImageresult(file.name);
      //     const reader = new FileReader();
      //     reader.readAsDataURL(file);
      //     reader.onload = (event) => {
      //         setGetImageresult(reader.result);
      //   };
    }
  };

  const handleChange = (e) => {
    if (e.target.files.length) {
      setImage({
        preview: URL.createObjectURL(e.target.files[0]),
        raw: e.target.files[0],
      });
      // console.log(image, "101823");
    }
  };

  const onCountry = (e) => {
    const selectedCountry = e.target.value;
    setCountry(selectedCountry);
    const states = State.getStatesOfCountry(selectedCountry);
    setState("");
    setStateData(states);
    setCity("");
    setCityData([]);
  };

  const onState = (e) => {
    const selectedState = e.target.value;
    setState(selectedState);
    const cities = City.getCitiesOfState(country, selectedState);
    setCity("");
    setCityData(cities);
  };

  const onCity = (e) => {
    setCity(e.target.value);
  };

  const onCompanyName = (e) => {
    setCompanyName(e.target.value);
  };

  const onCompanyUrl = (e) => {
    setCompanyUrl(e.target.value);
  };
  const onEmployee = (e) => {
    setEmployee(e.target.value);
  };
  const onOperatorUnit = (e) => {
    setOperatorUnit(e.target.value);
  };
  const onSupplier = (e) => {
    setSupplier(e.target.value);
  };

  const onJobTitle = (e) => {
    setJobtitle(e.target.value);
  };

  const onPinCode = (e) => {
    setPinCode(e.target.value);
  };

  const onAddress = (e) => {
    setAddress(e.target.value);
  };

  const onfirstName = (e) => {
    setFirstName(e.target.value);
  };

  const onLastName = (e) => {
    setLastName(e.target.value);
  };

  const onphoneNumber = (e) => {
    setPhoneNumber(e.target.value);
  };

  const onEmail = (e) => {
    setEmail(e.target.value);
  };

  const onPassword = (e) => {
    const value = e.target.value;
    setPassword(value);
    setHasUpperCase(/(?=.*[A-Z])/.test(value));
    setHasLowerCase(/(?=.*[a-z])/.test(value));
    setHasNumber(/(?=.*\d)/.test(value));
    setHasSpecialChar(/(?=.*[@$!%*?&])/.test(value));
    setMinTenChars(value.length >= 10);
    setPassword(e.target.value);
  };

  const onConfirmPassword = (e) => {
    setConfirmPassword(e.target.value);
  };

  //submit register
  const onRegister = () => {
    // console.log(getImage, "raja");

    let formData = new FormData();

    formData.append("profilePic", getImage);
    formData.append("companyName", companyName);
    formData.append("jobTitle", jobTitle);
    formData.append("firstName", firstname);
    formData.append("lastName", lastname);
    formData.append("country", country);
    formData.append("No_of_Emp", employee);
    formData.append("No_of_Operate_Unit", operatorUnit);
    formData.append("No_of_Suppliers", supplier);
    formData.append("want_to_viridi_supplier", onlySupplier);
    formData.append(
      "want_to_number_of_comapny_viridi_supplier",
      companySupplier
    );
    // formData.append(
    //   "countryCode",
    //   countryData.find((c) => c.isoCode === country)?.isoCode
    // );
    formData.append("state", state);
    // formData.append(
    //   "stateCode",
    //   stateData.find((c) => c.isoCode === state)?.isoCode
    // );
    formData.append("city", city);
    formData.append("address", address);
    formData.append("phone", phone);
    formData.append("email", email);
    formData.append("companyWebsiteUrl", companyUrl);
    formData.append("password", confirmPassword);
    formData.append("zipcode", pinCode);

    if (getImage === null) {
      toast.error("Please upload profile picture");
    } else if (companyName === "") {
      toast.error("Please type company name");
    } else if (jobTitle === "") {
      toast.error("Please type Job title");
    } else if (country === "") {
      toast.error("Please select country");
    } else if (country === "") {
      toast.error("Please select country");
    } else if (pinCode === "") {
      toast.error("Please type zip code");
    } else if (state === "") {
      toast.error("Please select state");
    } else if (city === "") {
      toast.error("Please select city");
    } else if (address === "") {
      toast.error("Please type your address");
    } else if (firstname === "") {
      toast.error("Please type your first name");
    } else if (lastname === "") {
      toast.error("Please type your last name");
    } else if (phone === "") {
      toast.error("Please type your phone number");
    } else if (email === "") {
      toast.error("Please type your email address");
    } else if (password === "") {
      toast.error("Please type your password");
    } else if (password.length < 10) {
      toast.error("Please type a 10-digit password");
    } else if (
      !/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/.test(
        password
      )
    ) {
      toast.error(
        "Password must have at least one uppercase letter, one lowercase letter, one special character, and one number"
      );
    }

    // else if (password === "") {
    //   toast.error("Please type your password");
    // } else if (password.length < 8) {
    //   toast.error("Please type 8 digit password");
    // }
    else if (confirmPassword === "") {
      toast.error("Please type your confirm password");
    } else if (confirmPassword != password) {
      toast.error("Confirm password did not match");
    } else if (check === false) {
      toast.error(
        "You must accept terms and conditions to register an account"
      );
    } else {
      // console.log("formdata");
      // console.log(JSON.stringify(formData));
      // Print all contents of the form
      for (var pair of formData.entries()) {
        // console.log(pair[0] + ", " + pair[1]);
      }
      // console.log("formdata");

      getRegister(formData, (r) => {
        // console.log(r, "response");
        if (r.success === true) {
          toast.success(r.message);
          navigate("/");
        } else {
          // console.log("nononononono");
          toast.error(r.message);
        }
      });
    }
  };

  // console.log("onlySupplier", onlySupplier, companySupplier);

  return (
    <>
      <div className="signupbg registerBg">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text-center pt-5 pb-3">
                <span className="logo">
                  <a href="#">
                    <img src={logo} alt="" />
                  </a>
                </span>

                <p>
                  Enter information as a buyer about the number of vendors and
                  business units so that we can make you an offer for a
                  subscription to the VIRIDI web solution.
                </p>
                <p>
                  Companies can have a subscription as a buyer and also as a
                  vendor to communicate defined product and service information
                  to their customers. As per below:
                </p>
                <div className="text-secondary">
                  <div>1. Company as Vendor</div>
                  <div>2. Company as a Buyer: 1-25 Vendors</div>
                  <div>3. Company as a Buyer: 26 - 50 Vendors</div>
                  <div>4. Company as a Buyer: 51-100 Vendors</div>
                  <div>5. Company as a Buyer: 101-500 Vendors</div>
                  <div>6. Company as a Buyer: Unlimited numbers of Vendors</div>
                </div>

                {/* <div
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "50%",
                    margin: "0 auto",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  <div className="justify-content-between">
                    <div style={{ fontWeight: "bold" }}>
                      1. Company as Vendor
                    </div>
                    <div></div>
                  </div>
                  <div className="justify-content-between">
                    <div style={{ fontWeight: "bold" }}>
                      2. Company as a Buyer:{" "}
                    </div>
                    <div>1-25 Vendors</div>
                  </div>
                </div> */}

                {/* <p>
                  Want to become a supplier only with Viridi?{" "}
                  <Link to={"/contactus"} style={{ color: "#4dba06" }}>
                    Please Contact Us
                  </Link>{" "}
                </p>
                <br></br>
                <p>Fill the details and create your account as purcheser</p> */}
              </div>

              <div className="supplRadio">
                <span style={{ fontSize: "17px" }}>
                  <label htmlFor="only_supplier" style={{ display: "flex" }}>
                    <input
                      type="radio"
                      name="onlySupplier"
                      id="only_supplier"
                      style={{ height: "20px", width: "20px" }}
                      checked={onlySupplier}
                      onClick={() => setOnlySupplier(!onlySupplier)}
                    />
                    {"Vendor in VIRIDI"}
                  </label>
                </span>
                <span style={{ fontSize: "17px" }}>
                  <label htmlFor="company_supplier" style={{ display: "flex" }}>
                    <input
                      type="radio"
                      name="companySupplier"
                      id="company_supplier"
                      style={{ height: "20px", width: "20px" }}
                      checked={companySupplier}
                      onClick={() => setCompanySupplier(!companySupplier)}
                    />
                    {"Buyer in VIRIDI"}
                  </label>
                </span>
              </div>

              <div className="loginBase">
                <form>
                  <div className="regdTop pb-4">
                    <div className="upld">
                      <label htmlFor="upload-button" className="uploadBtn">
                        {image.preview ? (
                          <img
                            src={image.preview}
                            alt="dummy"
                            width="300"
                            height="300"
                          />
                        ) : (
                          <>
                            <span className="fa-stack fa-2x">
                              <i className="fa-solid fa-plus"></i>
                            </span>
                          </>
                        )}
                      </label>
                      <p className=" m-0">
                        Upload profile image or Logo
                        <br /> (Please select jpg or png logo image)
                      </p>
                      <input
                        type="file"
                        id="upload-button"
                        style={{ display: "none" }}
                        // onChange={handleChange}
                        onChange={onFile}
                      />
                      <br />
                    </div>
                    <h6>
                      Already have an account?{" "}
                      <a href="#" onClick={() => navigate("/")}>
                        Login
                      </a>
                    </h6>
                  </div>

                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <label htmlFor="companyname">Company Name</label>
                      <input
                        type="text"
                        id="companyname"
                        className="form-control"
                        placeholder="Company Name"
                        name="companyname"
                        onChange={onCompanyName}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="companyurl">Company Url</label>
                      <input
                        type="text"
                        id="companyurl"
                        className="form-control"
                        placeholder="Company Url"
                        name="companyurl"
                        onChange={onCompanyUrl}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="jobTitle">Job Title</label>
                      <input
                        type="text"
                        id="jobTitle"
                        className="form-control"
                        placeholder="Job Title"
                        name="jobTitle"
                        onChange={onJobTitle}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="companyurl">Number of Employees</label>
                      <input
                        type="number"
                        id="number_of_employees"
                        className="form-control"
                        placeholder="Number of Employees"
                        name="number_of_employees"
                        onChange={onEmployee}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="companyurl">
                        Number of Operating units
                      </label>
                      <input
                        type="number"
                        id="number_of_operating_units"
                        className="form-control"
                        placeholder="Number of Operating units"
                        name="number_of_operating_units"
                        onChange={onOperatorUnit}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="supplier">Number of Vendors</label>
                      <select
                        className="form-control"
                        name="number_of_suppliers"
                        onChange={onSupplier}
                      >
                        <option value="">Select Number of Vendors</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={200}>200</option>
                        <option value={500}>500</option>
                        <option value={"Unlimited"}>Unlimited</option>
                      </select>
                    </div>

                    <div className="col-md-6 mb-3">
                      <label htmlFor="country">Country</label>
                      <select
                        className="form-control"
                        id="country"
                        onChange={onCountry}
                      >
                        <option selected hidden>
                          Select country
                        </option>

                        {countryData.map((con) => (
                          <option value={con.isoCode}>{con.name}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="zipcode">Zip Code</label>
                      <input
                        type="text"
                        id="zipcode"
                        className="form-control"
                        placeholder="Zip Code"
                        name=""
                        onChange={onPinCode}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="state">State</label>
                      <select
                        className="form-control"
                        id="state"
                        onChange={onState}
                        value={state} // Set the selected value
                      >
                        <option value="">Select state</option>
                        {stateData.map((sta) => (
                          <option key={sta.isoCode} value={sta.isoCode}>
                            {sta.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-6 mb-3">
                      <label htmlFor="city">City</label>
                      <select
                        className="form-control"
                        id="city"
                        onChange={onCity}
                        value={city} // Set the selected value
                      >
                        <option value="">Select city</option>
                        {cityData.map((cit) => (
                          <option key={cit.name} value={cit.name}>
                            {cit.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* <div className="col-md-6 mb-3">
                      <label htmlFor="state">State</label>
                      <select
                        className="form-control"
                        id="state"
                        onChange={onState}
                      >
                        <option>
                          Select state
                        </option>
                        {stateData.map((sta) => (
                          <option value={sta.isoCode}>{sta.name}</option>
                        ))}
                      </select>
                    </div> */}
                    {/* <div className="col-md-6 mb-3">
                      <label htmlFor="city">City</label>
                      <select
                        className="form-control"
                        id="city"
                        onChange={onCity}
                      >
                        <option>
                          Select city
                        </option>

                        {cityData.map((cit) => (
                          <option value={cit.name}>{cit.name}</option>
                        ))}
                      </select>
                    </div> */}
                    <div className="col-md-12 mb-3">
                      <label htmlFor="address">Address</label>
                      <textarea
                        className="form-control"
                        id="address"
                        placeholder="Address"
                        onChange={onAddress}
                      ></textarea>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="firstName">First Name</label>
                      <input
                        type="text"
                        id="firstName"
                        className="form-control"
                        placeholder="First Name"
                        name=""
                        onChange={onfirstName}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="lastName">Last Name</label>
                      <input
                        type="text"
                        id="lastName"
                        className="form-control"
                        placeholder="Last Name"
                        name=""
                        onChange={onLastName}
                      />
                    </div>
                    <div className="col-md-6 mb-3 phoneInputDropdown">
                      <label htmlFor="Phone">Phone</label>
                      <PhoneInput
                        defaultCountry="ua"
                        value={phone}
                        className="phInp"
                        onChange={(phone) => setPhone(phone)}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="email">Email</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        autocomplete="new-email"
                        className="form-control"
                        placeholder="Email Address"
                        onChange={onEmail}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="password">Password</label>
                      <div className="mb-4">
                        <div className="showHide">
                          <input
                            className="form-control"
                            name="password"
                            type={showpassword ? "text" : "password"}
                            id="password"
                            autocomplete="new-password"
                            placeholder="New Password"
                            onChange={onPassword}
                          />
                          <div
                            className="input-group-addon eyeAbs"
                            onClick={() => {
                              setShowPassword(!showpassword);
                            }}
                          >
                            {showpassword === true ? (
                              <span>
                                <i className="fa fa-eye" aria-hidden="true"></i>
                              </span>
                            ) : (
                              <span>
                                <i
                                  className="fa fa-eye-slash"
                                  aria-hidden="true"
                                ></i>
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="passwordStrength">
                          <span
                            style={{
                              color: hasUpperCase ? "green" : "#7f7373",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={hasUpperCase}
                              readOnly
                              className="cursor-not-allowed"
                            />
                            A-Z
                          </span>
                          <span
                            style={{
                              color: hasLowerCase ? "green" : "#7f7373",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={hasLowerCase}
                              readOnly
                              className="cursor-not-allowed"
                            />
                            a-z
                          </span>
                          <span
                            style={{ color: hasNumber ? "green" : "#7f7373" }}
                          >
                            <input
                              type="checkbox"
                              checked={hasNumber}
                              readOnly
                              className="cursor-not-allowed"
                            />
                            0-9
                          </span>
                          <span
                            style={{
                              color: hasSpecialChar ? "green" : "#7f7373",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={hasSpecialChar}
                              readOnly
                              className="cursor-not-allowed"
                            />
                            @#$%...
                          </span>
                          <span
                            style={{ color: minTenChars ? "green" : "#7f7373" }}
                          >
                            <input
                              type="checkbox"
                              checked={minTenChars}
                              readOnly
                              className="cursor-not-allowed"
                            />
                            Min 10 Characters
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="confirmpassword">Confirm Password</label>
                      <div className="mb-4">
                        <div className="showHide">
                          <input
                            className="form-control"
                            name="conformpassword"
                            type={showconfirmpassword ? "text" : "password"}
                            id="confirmpassword"
                            placeholder="Confirm Password"
                            onChange={onConfirmPassword}
                          />
                          <div
                            className="input-group-addon eyeAbs"
                            onClick={() => {
                              setShowConfirmPassword(!showconfirmpassword);
                            }}
                          >
                            {showconfirmpassword === true ? (
                              <span>
                                <i className="fa fa-eye" aria-hidden="true"></i>
                              </span>
                            ) : (
                              <span>
                                <i
                                  className="fa fa-eye-slash"
                                  aria-hidden="true"
                                ></i>
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="regdBtm">
                    <p style={{ position: "relative" }}>
                      <input type="checkbox" id="terms" onClick={onCheckbox} />
                      <label for="terms">
                        I accept Terms &amp; Conditions , Privacy Policy
                      </label>
                    </p>
                    <button
                      type="button"
                      className="commonButton"
                      onClick={onRegister}
                    >
                      Send the Request
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Register;
